import type { ApiConfig } from '../../types'

export const withdrawalHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 50,
  order: 'desc',
  range: 30 * 24 * 60 * 60 * 1000,
  requiresRange: true,
  type: 'withdrawal-history',
} as const satisfies ApiConfig
